import { Match } from '@/types'
import React, { createContext } from 'react'

export const matchesContext = createContext<{
  matches: Match[] | null
  setMatches?: React.Dispatch<React.SetStateAction<Match[]>>
  setOffset?: React.Dispatch<React.SetStateAction<number>>
}>({
  matches: null,
})
